import { memo } from 'react';

type HtmlContentProps = {
  html: string;
  className?: string;
};

function HtmlContent({ html, className }: HtmlContentProps) {
  if (!html?.trim()) return null;

  return (
    <div
      suppressHydrationWarning
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default memo(HtmlContent);
